<template>
  <lb-drawer
    :value="value"
    :heading="isEdit ? 'Edit Information Owner' : 'Add New Information Owner'"
    :loading="loading"
    @input="$emit('input', $event)"
    data-testid="info-owner-drawer"
  >
    <template v-slot:body>
      <v-row class="mt-3">
        <!-- Name Field -->
        <v-col cols="12" class="my-0 py-0">
          <lb-string
            :value="infoOwner.name"
            @input="updateField('name', $event)"
            label="Name"
            :error="errors.name"
            data-testid="info-owner-drawer__name"
          />
        </v-col>

        <!-- Email Field -->
        <v-col cols="12" class="my-0 py-0">
          <lb-string
            :value="infoOwner.email"
            @input="updateField('email', $event)"
            label="Email"
            :error="errors.email"
            data-testid="info-owner-drawer__email"
          />
        </v-col>
      </v-row>
    </template>

    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn
        v-if="isEdit"
        color="primary"
        class="white--text"
        @click="$emit('update')"
        data-testid="info-owner-drawer__update-btn"
      >
        <span>Update</span>
      </v-btn>
      <v-btn
        v-else
        color="primary"
        class="white--text"
        @click="$emit('add')"
        data-testid="info-owner-drawer__add-btn"
      >
        <span>Add</span>
      </v-btn>
    </template>
  </lb-drawer>
</template>

<script>
export default {
  name: 'InfoOwnerDrawer',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    infoOwner: {
      type: Object,
      default: () => ({}),
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    /**
     * Determines if we're in edit mode based on presence of _id
     * @returns {boolean}
     */
    isEdit() {
      return !!this.infoOwner._id;
    },
  },
  methods: {
    /**
     * Emits field update event with field name and value
     * @param {string} field - The field name to update
     * @param {any} value - The new value
     */
    updateField(field, value) {
      this.$emit('update-field', { field, value });
    },
  },
};
</script>
